"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiVersion = void 0;
var ApiVersion;
(function (ApiVersion) {
    ApiVersion["v0"] = "20200115";
    ApiVersion["v1"] = "20240226";
})(ApiVersion || (exports.ApiVersion = ApiVersion = {}));
